import { render, staticRenderFns } from "./BusinessContactEdit.vue?vue&type=template&id=2e4b93ca"
import script from "./BusinessContactEdit.vue?vue&type=script&lang=js"
export * from "./BusinessContactEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports